import { GenericRadioChoiceStep } from '@eneco/flows/components';
import { FlowRoute, FlowRouteCategory, FlowActions } from '@eneco/flows/types';

import { AddressStep } from './steps/AddressStep/AddressStep';
import { ContactDetailsStep } from './steps/ContactDetailsStep/ContactDetailsStep';
import { PersonalDetailsStep } from './steps/PersonalDetailsStep/PersonalDetailsStep';
import { SolarBoilerLeadFlowContext } from './types/context';

export const initialContext: SolarBoilerLeadFlowContext = {};

export const routes: FlowRoute<SolarBoilerLeadFlowContext>[] = [
  {
    id: 'ADDRESS',
    path: '/adres/',
    category: FlowRouteCategory.YourPostcode,
    component: AddressStep,
  },
  {
    id: 'SOLAR_PANELS',
    path: '/zonnepanelen/',
    category: FlowRouteCategory.YourSolarPanels,
    component: GenericRadioChoiceStep,
  },
  {
    id: 'SMART_METER',
    path: '/slimme-meter/',
    category: FlowRouteCategory.YourSmartMeter,
    component: GenericRadioChoiceStep,
  },
  {
    id: 'PERSONAL_DETAILS',
    path: '/je-gegevens/persoonlijke-gegevens/',
    category: FlowRouteCategory.YourData,
    component: PersonalDetailsStep,
  },
  {
    id: 'CONTACT_DETAILS',
    path: '/je-gegevens/contactgegevens/',
    category: FlowRouteCategory.YourData,
    component: ContactDetailsStep,
  },
];

export const actions: FlowActions<SolarBoilerLeadFlowContext> = {};
